import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: Infinity,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      placeholderData: {},
      cacheTime: 0,
    },
  },
});

export default queryClient;
